export enum ContractsLocation {
  LOCAL = 'LOCAL',
  REMOTE = 'REMOTE',
}
